import React from 'react';
import styled from 'styled-components'
import { Black, WerfenColor } from '../../Constants/ColorChart'

/*
 *  @Description:   Stateless component that renders a Icon Wraper.
 */

const StyledIcon = styled.svg`
	fill: ${ props => props.fillColor ? props.fillColor : "none" };
    stroke: ${ props => props.color ? props.color : Black };
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-miterlimit: 10;
    stroke-width: ${ props => props.strokeWidth ? props.strokeWidth : "3.5px" };
    width: ${ props => props.width ? props.width : "40px" };
    padding: 1px;
    ${ props => props.iconStyle && props.iconStyle };

`;

const IconWrapper = ( { color, width, strokeWidth, height, fillColor, fillSecondaryColor, iconStyle, onClick, Icon, isActive } ) => {

    return (<StyledIcon
            color={ color }
            width={ width }
            height={ height }
            strokeWidth={ strokeWidth }
            fillColor={ fillColor }
            iconStyle={ iconStyle }
            onClick={ onClick }
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 124.225 124.225"
        >
            <Icon fillSecondaryColor={ fillSecondaryColor }
                  isActive={ isActive }
            />
        </StyledIcon>
    )
};


export default IconWrapper;

